const images = {
    device: require('./device-img.png'),
    loading: require('./loading.svg').default
};

export default images